import { useQuickFilters } from "@PN/tabela";

/**
 * Props do componente QuickFilter
 */
export interface QuickFilterProps {
  /** Callback opcional executado quando um filtro é aplicado */
  onApplyFilter?: (field: string, value: any) => void;
}

/**
 * Hook customizado para QuickFilter com callbacks
 */
export function useQuickFilterWithCallbacks(
  onApplyFilter?: (field: string, value: any) => void
) {
  const { filterOptions, currentFilters, handlers, formatters } =
    useQuickFilters();

  // Handlers com callbacks
  const handleFilialChange = (value: string[] | undefined) => {
    handlers.handleFilialChange(value);
    onApplyFilter?.("F1_FILIAL", value || []);
  };

  const handleStatusChange = (value: string[] | undefined) => {
    handlers.handleStatusChange(value);
    onApplyFilter?.("Status", value || []);
  };

  const handleTipoChange = (value: string[] | undefined) => {
    handlers.handleTipoChange(value);
    onApplyFilter?.("F1_XTIPO", value || []);
  };

  return {
    filterOptions,
    currentFilters,
    handlers: {
      ...handlers,
      handleFilialChange,
      handleStatusChange,
      handleTipoChange,
    },
    formatters,
  };
}
